export default __webpack_public_path__ + "static/media/google_play.0dc1a49b.png";